/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const alertTokens = {
  ContainerBorderRadiusBaseDefault: '0px',
  ContainerBorderStyleBaseDefault: 'solid',
  ContainerBorderWidthBaseDefault: '1px',
  ContainerBorderColorPositiveDefault: '#5bc0b3',
  ContainerBorderColorNoticeDefault: '#ea957b',
  ContainerBorderColorPendingDefault: '#f8d648',
  ContainerBorderColorNegativeDefault: '#e14963',
  ContainerShadowOffsetXBaseDefault: '0px',
  ContainerShadowOffsetYBaseDefault: '4px',
  ContainerShadowBlurBaseDefault: '2px',
  ContainerShadowSpreadBaseDefault: '0px',
  ContainerShadowColorBaseDefault: 'rgba(0, 0, 0, 0.1)',
  ContainerSpacingInnerVerticalBaseDefault: '16px',
  ContainerSpacingInnerHorizontalBaseDefault: '12px',
  ContainerSizeWidthBaseDefault: '400px',
  ContainerOutlineOffsetBaseKeyboardFocus: '0px',
  ContainerOutlineStrokeBaseKeyboardFocus: '2px solid',
  ContainerOutlineColorBaseKeyboardFocus: '#285da3',
  ContainerBackgroundColorPositiveDefault: '#d6efec',
  ContainerBackgroundColorNoticeDefault: '#fcf0ee',
  ContainerBackgroundColorPendingDefault: '#fef8da',
  ContainerBackgroundColorNegativeDefault: '#f8d2d8',
  ContentSpacingOuterHorizontalBaseDefault: '12px',
} as const;
